import { Box, Chip, Stack, Typography } from "@mui/material";
import type { PageFilterGroup, PageFilterSelection } from "./PageLayout.types";
import { isFilterSelected } from "./pageFilters";

interface FilterChipRowProps {
	group: PageFilterGroup;
	selection: PageFilterSelection;
	onToggle: (groupId: string, value: string) => void;
}

/** One group's options as toggle chips. `aria-pressed` carries the on/off state; colour alone
 *  would not. */
export function FilterChipRow(props: FilterChipRowProps) {
	const group = props.group;
	return (
		<Box role="group" aria-label={group.label} sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
			{group.options.map((option) => {
				const on = isFilterSelected(props.selection, group.id, option.value);
				return (
					<Chip
						key={option.value}
						label={option.label}
						color={on ? "primary" : "default"}
						variant={on ? "filled" : "outlined"}
						aria-pressed={on}
						onClick={() => props.onToggle(group.id, option.value)}
					/>
				);
			})}
		</Box>
	);
}

interface FilterGroupsProps {
	groups: readonly PageFilterGroup[];
	selection: PageFilterSelection;
	onToggle: (groupId: string, value: string) => void;
}

/** Every group, each under its own heading: the body of the desktop popover and the phone sheet. */
export function FilterGroups(props: FilterGroupsProps) {
	return (
		<Stack spacing={2}>
			{props.groups.map((group) => (
				<Stack key={group.id} spacing={1}>
					<Typography variant="label" color="text.secondary" component="div">
						{group.label}
					</Typography>
					<FilterChipRow group={group} selection={props.selection} onToggle={props.onToggle} />
				</Stack>
			))}
		</Stack>
	);
}
